import { connect } from 'react-redux'
import DirectMessages from '../components/direct-messages'

const mapStateToProps = state => ({...state.directMessages})

const mapDispatchToProps = dispatch => ({
  openChannel: payload => dispatch({type: 'DIRECT_MESSAGES.OPEN_CHANNEL', payload}),
  selectChannel: payload => dispatch({type: 'DIRECT_MESSAGES.CHANNEL_OPENED', payload}),
  updatePlayer: payload => dispatch({type: 'DIRECT_MESSAGES.UPDATE_PLAYER', payload}),
  sendMessage: payload => dispatch({type: 'DIRECT_MESSAGES.SEND', payload}),
  sendFile: payload => dispatch({type: 'DIRECT_MESSAGES.SEND_FILE', payload}),
  deleteMessage: payload => dispatch({type: 'DIRECT_MESSAGES.DELETE', payload}),
  loadChannels: payload => dispatch({type: 'DIRECT_MESSAGES.LOAD_CHANNELS', payload}),
  closeChannel: payload => dispatch({type: 'DIRECT_MESSAGES.CLOSE_CHANNEL', payload}),
  fetchMore: payload => dispatch({type: 'DIRECT_MESSAGES.FETCH_MORE', payload}),
  unsubscribe: payload => dispatch({type: 'DIRECT_MESSAGES.UNSUBSCRIBE', payload}),
  selectPlayer: payload => dispatch({type: 'DIRECT_MESSAGES.SELECT_PLAYER', payload}),
  selectPlayers: payload => dispatch({type: 'DIRECT_MESSAGES.SELECT_PLAYERS', payload}),
  removePlayer: payload => dispatch({type: 'DIRECT_MESSAGES.REMOVE_PLAYER', payload}),
})

export default connect(mapStateToProps, mapDispatchToProps)(DirectMessages)
